import { render } from "./AreaConcentracaoBugs.vue?vue&type=template&id=fa0c1f62"
import script from "./AreaConcentracaoBugs.vue?vue&type=script&lang=js"
export * from "./AreaConcentracaoBugs.vue?vue&type=script&lang=js"

import "./AreaConcentracaoBugs.vue?vue&type=style&index=0&id=fa0c1f62&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__